module.exports = __webpack_public_path__ + "static/media/trash.40068010.svg";